import "core-js/modules/es.error.cause.js";
import quillConfig from '@/views/components/editor/quill-config.js';
import { quillEditor } from 'vue-quill-editor';
import { clipboardCopy } from '@/utils/clipboard';
import { systemConfigStore, systemConfigCheckFilename, systemConfigEdit, systemConfigFileList } from '../request';
export default {
  props: {
    modalVisible: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      required: true,
      default: ''
    },
    itemData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      title: '新增',
      form: {
        name: '',
        fileContent: ''
      },
      quillOption: quillConfig,
      type: '2',
      //条款文件列表
      fileList: [],
      fileId: undefined,
      isCopySuccessDisplayed: false,
      confirmLoading: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.modalVisible;
      },
      set(val) {
        this.$emit('update:modalVisible', val);
      }
    },
    rules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('文件名称'),
          trigger: 'blur'
        }],
        fileContent: [{
          required: true,
          validator: this.checkEditorCont,
          trigger: 'change'
        }]
      };
    }
  },
  mounted() {
    var _this$itemData;
    if ((_this$itemData = this.itemData) !== null && _this$itemData !== void 0 && _this$itemData.id) {
      this.title = '编辑';
      this.form = {
        name: this.itemData.name,
        fileContent: this.itemData.fileContent
      };
    } else {
      this.title = '新增';
    }
    this.getSystemConfigFileList();
  },
  methods: {
    // 校验富文本是否有真实内容
    checkEditorCont(rule, value, callback) {
      const editorContent = this.$refs.myTextEditor.quill.root.innerHTML;
      // 使用DOMParser解析HTML字符串为DOM对象
      const parser = new DOMParser();
      const doc = parser.parseFromString(editorContent, 'text/html');
      // 获取解析后的文本内容
      const textContent = doc.body.textContent || '';
      console.log(textContent, 'textContent');
      const trimContent = textContent.trim();
      console.log(trimContent, 'trimContent', !trimContent, !editorContent.includes('<img'));
      if (!trimContent && !editorContent.includes('<img')) {
        callback(new Error(this.$t('请输入') + this.$t('文件内容')));
      } else {
        callback();
      }
    },
    // 前后空格去除
    async handleBlurTrim(field) {
      var _this$itemData2, _this$itemData3;
      this.form[field] = this.form[field].trim();
      // 校验是否为空
      if (!this.form[field]) return;
      let res = await systemConfigCheckFilename({
        id: (_this$itemData2 = this.itemData) !== null && _this$itemData2 !== void 0 && _this$itemData2.id ? (_this$itemData3 = this.itemData) === null || _this$itemData3 === void 0 ? void 0 : _this$itemData3.id : undefined,
        name: this.form.name,
        language: this.language
      });
    },
    // 获取文件列表
    async getSystemConfigFileList() {
      let res = await systemConfigFileList({
        language: this.language,
        page: 1,
        pageSize: 9999999
      });
      this.fileList = res.items;
    },
    // 文件选择
    fileChange(value) {
      this.fileId = value;
    },
    // 复制
    handleCopy(item, event) {
      console.log(item, '复制的item');
      let msg = item !== 'undefined' ? this.$t('复制成功') : this.$t('请选择') + this.$t('链接文件');
      let newLink = `${process.env.VUE_APP_BASE_URL}/system/settings/previewPage/${this.fileId}/${this.language}/2`;
      if (item === 'undefined') {
        newLink = '';
      }
      clipboardCopy(false, newLink, event, msg);
    },
    // 确认
    confirmModal() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          var _this$itemData4;
          this.confirmLoading = true;
          if ((_this$itemData4 = this.itemData) !== null && _this$itemData4 !== void 0 && _this$itemData4.id) {
            var _this$itemData5;
            // 编辑
            await systemConfigEdit({
              id: (_this$itemData5 = this.itemData) === null || _this$itemData5 === void 0 ? void 0 : _this$itemData5.id,
              type: this.type,
              language: this.language,
              name: this.form.name,
              fileContent: this.form.fileContent
            }).then(res => {
              console.log(res, '-------------then--------');
              this.visible = false;
              this.$emit('saveSuccess');
              this.form = {
                name: '',
                fileContent: ''
              };
              this.confirmLoading = false;
            }).catch(err => {
              console.log(err, '-------------catch--------');
              this.confirmLoading = false;
            });
          } else {
            await systemConfigStore({
              type: this.type,
              language: this.language,
              name: this.form.name,
              fileContent: this.form.fileContent
            }).then(res => {
              console.log(res, '-------------then--------');
              this.visible = false;
              this.$emit('saveSuccess');
              this.form = {
                name: '',
                fileContent: ''
              };
              this.confirmLoading = false;
            }).catch(err => {
              console.log(err, '-------------catch--------');
              this.confirmLoading = false;
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 取消
    cancleModal() {
      this.visible = false;
      this.form = {
        name: '',
        fileContent: ''
      };
      this.confirmLoading = false;
    }
  }
};